import { ComponentProps, ReactNode, createContext } from "react";

const defaultValue = {
  pageData: {},
};

export const PageContext = createContext(defaultValue);

interface PageProviderProps
  extends ComponentProps<typeof PageContext.Provider> {
  children: ReactNode;
  value: any;
}

export const PageProvider = ({ children, ...props }: PageProviderProps) => {
  return <PageContext.Provider {...props}>{children}</PageContext.Provider>;
};
